(function () {
  'use strict';
  if (window.SoulyshineDrawer) return;
  var VERSION = '20260910-1';
  var drawer, originalRender, originalOpen, originalClose, model;
  var running = Promise.resolve(), busy = false, currentCart = null;
  var queuedRefresh = false, refreshTimer, nativeRendering = false;
  var pendingTasks = 0, pendingAddRenders = 0, externalRevision = 0;
  var earlyAdds = [];
  var closeRevision = 0;
  var interactionRevision = 0, taskFocus = null, pendingFocusRestore = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
  // Shopify removes the preview query after loading a draft. Keep section
  // requests on that draft even when preview cookies are unavailable to Ajax.
  if (!previewId && window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'unpublished') previewId = String(window.Shopify.theme.id);
  function route(value) { return root.replace(/\/?$/, '/') + value; }
  function contextUrl() {
    var url = new URL(route('cart'), window.location.origin);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    return url;
  }
  function sectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return ids;
  }
  async function request(url, options) {
    var response = await fetch(url, Object.assign({credentials:'same-origin', headers:{Accept:'application/json'}}, options));
    var body = await response.json().catch(function () { return {}; });
    if (!response.ok || body.errors) throw new Error(body.description || body.message || (typeof body.errors === 'string' ? body.errors : 'Your cart could not be updated. Please try again.'));
    return body;
  }
  function readCart() { return request(route('cart.js')); }
  var sessionPromise;
  function readySession() {
    if(sessionPromise)return sessionPromise;
    if((currentCart&&currentCart.item_count>0)||/(?:^|;\s*)cart=/.test(document.cookie||''))return Promise.resolve();
    sessionPromise=request(route('cart/update.js?customily_upsell=1'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:'{}'});
    return sessionPromise.catch(function(e){sessionPromise=null;throw e;});
  }

  function signature(cart) {
    return JSON.stringify((cart.items || []).map(function (i) {return [i.key, i.quantity, i.final_line_price, (i.properties || {})['_customily-preview']];}));
  }
  async function settledCart() {
    var previous = await readCart(), stable = 0;
    for (var i=0; i<8; i++) {
      await new Promise(function (resolve) {setTimeout(resolve, 250);});
      var next = await readCart();
      stable = signature(previous) === signature(next) ? stable + 1 : 0;
      previous = next;
      if (stable >= 2) return next;
    }
    return previous;
  }
  async function sections() {
    var url = contextUrl(); url.searchParams.set('sections', sectionIds().join(','));
    // /cart negotiates Accept: application/json as the cart data endpoint,
    // even with sections present. Request the HTML route for section JSON.
    var result = await request(url.toString(), {headers:{Accept:'text/html'}});
    if (!result['cart-drawer'] || result['cart-drawer'].indexOf('data-ss-drawer-version="'+VERSION+'"') < 0 || !result['cart-icon-bubble']) {
      throw new Error('The cart view could not be loaded. Please refresh the page and open your cart again.');
    }
    return result;
  }
  function seedCart() {
    var el = drawer && drawer.querySelector('[data-ss-cart-state]');
    if (!el) return null;
    try {return JSON.parse(el.textContent);} catch (_) {return null;}
  }
  // Shopify renders these sections in the same mutation that returns the Add
  // response. The embedded JSON is the full cart, not just the added line.
  function cartFromSections(result) {
    if (!result || sectionIds().some(function(id){return typeof result[id] !== 'string' || !result[id].trim();})) return null;
    var parsed=new DOMParser().parseFromString(result['cart-drawer'],'text/html');
    var shell=parsed.querySelector('cart-drawer[data-ss-drawer-version="'+VERSION+'"]');
    var seed=shell&&shell.querySelector('[data-ss-cart-state]');
    if (!seed) return null;
    try {
      var cart=JSON.parse(seed.textContent);
      if(!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count<0 ||
        !Number.isSafeInteger(cart.total_price) || cart.total_price<0) return null;
      model.groups(cart); // Also validates unique line keys and quantities.
      if(cart.items.reduce(function(sum,item){return sum+item.quantity;},0)!==cart.item_count) return null;
      return cart;
    } catch (_) {return null;}
  }
  function addedLines(state) {
    if(!state || state.status || state.errors) return [];
    return (Array.isArray(state.items)?state.items:(state.key?[state]:[])).map(function(item){
      var line=Object.assign({},item);delete line.sections;return line;
    });
  }
  function responseMatchesCart(cart, added) {
    if(!cart || !added.length) return false;
    // An Add cannot remove a previously acknowledged line. This also rejects
    // an older response that arrives after another design was already rendered.
    if(currentCart&&Array.isArray(currentCart.items)&&currentCart.items.some(function(previous){
      var next=cart.items.find(function(item){return item.key===previous.key;});
      return !next||next.quantity<previous.quantity;
    }))return false;
    return added.every(function(line){
      var item=cart.items.find(function(i){return i.key===line.key;});
      if(!item || !Number.isSafeInteger(line.quantity) || line.quantity<1 || item.quantity!==line.quantity) return false;
      var properties=line.properties||{};
      if(Object.keys(properties).some(function(key){return JSON.stringify(properties[key])!==JSON.stringify((item.properties||{})[key]);})) return false;
      var group=properties['_customily-upsell-main-id'];
      // In Customily's raw-fetch path, sections from the main request can
      // predate the addon request. Reconcile once after it has been acknowledged.
      return properties._ss_cu_offer || !group || cart.items.some(function(child){return (child.properties||{})['_customily-upsell-id']===group;});
    });
  }
  function rowFor(key) {
    return Array.from(drawer.querySelectorAll('[data-ss-cart-key]')).find(function (el) {return el.dataset.ssCartKey === key;});
  }
  function groupRows(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var index=0;
    model.groups(cart).forEach(function (group) {
      [group.item].concat(group.addons).forEach(function (item, child) {
        var row=rowFor(item.key); if (!row) return;
        row.style.order=String(index++);
        row.dataset.ssLinked=child ? 'true' : 'false';
      });
    });
  }
  function overlayOpen() {return !!(window.SoulyshineCartUI && window.SoulyshineCartUI.isOverlayOpen());}
  function setBusy(value) {
    value=!!value||earlyAdds.length>0;busy=value;
    if (!drawer) return;
    drawer.setAttribute('aria-busy',String(value));
    pendingView();
    document.querySelectorAll('cart-drawer [data-ss-cart-step], cart-drawer [data-ss-cart-remove], cart-drawer [data-ss-cart-quantity], cart-drawer [data-ss-cu-check], [data-ss-gift-accept], #CartDrawer-Checkout, #checkout').forEach(function (el) {
      if (value) {
        if (!Object.prototype.hasOwnProperty.call(el.dataset,'ssWasDisabled')) el.dataset.ssWasDisabled=el.disabled?'true':'false';
        el.disabled=true;
      } else if (Object.prototype.hasOwnProperty.call(el.dataset,'ssWasDisabled')) {
        el.disabled=el.dataset.ssWasDisabled==='true';delete el.dataset.ssWasDisabled;
      }
    });
  }
  function pendingConfig() {
    var el=drawer&&drawer.querySelector('[data-ss-cart-pending-config]');
    try{return el?JSON.parse(el.textContent):{};}catch(_){return {};}
  }
  function dogLoader() {
    var dog=document.createElement('span');dog.className='ss-cart-dog';dog.setAttribute('aria-hidden','true');
    dog.innerHTML='<span class="ss-cart-dog__head"><svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#273963" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M30 28C17 19 10 31 12 51C13 68 22 76 30 57" fill="#B78259"/><path d="M66 28C79 19 86 31 84 51C83 68 74 76 66 57" fill="#B78259"/><path d="M23 43C23 24 33 19 48 19C63 19 73 24 73 43V51C73 68 62 76 48 76C34 76 23 68 23 51Z" fill="#FFF1D5"/><path d="M40 21C39 30 46 33 51 25L53 20" fill="#B78259" stroke="none"/><ellipse cx="48" cy="58" rx="18" ry="14" fill="#FFFAEF" stroke="none"/><circle cx="31" cy="54" r="4" fill="#EFAAA1" stroke="none"/><circle cx="65" cy="54" r="4" fill="#EFAAA1" stroke="none"/><path d="M34 36Q38 33 42 36M54 36Q58 33 62 36"/><circle cx="38" cy="44" r="3" fill="#273963" stroke="none"/><circle cx="58" cy="44" r="3" fill="#273963" stroke="none"/><circle cx="37" cy="43" r="1" fill="white" stroke="none"/><circle cx="57" cy="43" r="1" fill="white" stroke="none"/><rect x="43" y="61" width="10" height="14" rx="5" fill="#EC9C9E"/><path d="M48 65V69M37 59Q42 66 48 60Q54 66 59 59M48 54V60"/><path d="M42 49C42 45 54 45 54 49C54 52 50 55 48 55C46 55 42 52 42 49Z" fill="#273963" stroke="none"/><path d="M34 76H62" stroke="#B78259" stroke-width="4"/><circle cx="48" cy="80" r="3" fill="#EDC86F" stroke-width="1.8"/></svg></span><span class="ss-cart-dog__dots"><i></i><i></i><i></i></span>';
    return dog;
  }
  function checkoutDogView() {
    document.querySelectorAll('#checkout').forEach(function(button){
      var icon=button.querySelector('[data-ss-cart-busy-dog]'),show=(busy&&!earlyAdds.length)||button.hasAttribute('data-ss-checkout-leaving');
      button.classList.toggle('ss-cart-dog-loading',show);
      if(show){
        if(!icon){icon=dogLoader();icon.setAttribute('data-ss-cart-busy-dog','');button.prepend(icon);}
        if(!Object.prototype.hasOwnProperty.call(button.dataset,'ssDogBusyBefore'))button.dataset.ssDogBusyBefore=button.getAttribute('aria-busy')||'';
        button.setAttribute('aria-busy','true');
      }else{
        if(icon)icon.remove();
        if(Object.prototype.hasOwnProperty.call(button.dataset,'ssDogBusyBefore')){
          if(button.dataset.ssDogBusyBefore)button.setAttribute('aria-busy',button.dataset.ssDogBusyBefore);else button.removeAttribute('aria-busy');
          delete button.dataset.ssDogBusyBefore;
        }
      }
    });
  }
  document.addEventListener('submit',function(event){
    var button=event.submitter;
    if(event.defaultPrevented||!button||button.name!=='checkout'||!event.target.matches('#cart,#CartDrawer-Form'))return;
    button.setAttribute('data-ss-checkout-leaving','');pendingView();
  });
  window.addEventListener('pageshow',function(){
    document.querySelectorAll('[data-ss-checkout-leaving]').forEach(function(button){button.removeAttribute('data-ss-checkout-leaving');});pendingView();
  });
  function pendingView() {
    checkoutDogView();
    if(!drawer)return;
    var inner=drawer.querySelector('.drawer__inner'),status=inner&&inner.querySelector('[data-ss-cart-pending]');
    var centered=busy||earlyAdds.length>0||!!drawer.querySelector('#CartDrawer-Checkout[data-ss-checkout-leaving]');
    drawer.toggleAttribute('data-ss-add-pending',centered);
    if(!centered){if(status)status.remove();return;}
    if(!inner||status)return;
    var config=pendingConfig();
    status=document.createElement('div');status.className='ss-cart-pending';status.setAttribute('data-ss-cart-pending','');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    status.appendChild(dogLoader());
    var message=document.createElement('p');message.textContent=config.adding||'';status.appendChild(message);
    var hint=document.createElement('p');hint.className='ss-cart-pending__hint';hint.textContent=config.hint||'';status.appendChild(hint);
    inner.appendChild(status);
  }
  function releaseAdd(token,message) {
    var index=earlyAdds.indexOf(token);if(index<0)return;
    clearTimeout(token.timer);earlyAdds.splice(index,1);setBusy(pendingTasks>0);
    if(message){
      error(message);
      var inner=drawer&&drawer.querySelector('.drawer__inner');
      if(inner){var alert=document.createElement('p');alert.className='ss-cart-add-error';alert.setAttribute('role','alert');alert.textContent=message;inner.appendChild(alert);}
    }
    if(queuedRefresh&&!busy)scheduleRefreshTimer();
  }
  function beginAdd(data,path) {
    if(!drawer||!originalOpen)return null;
    try{if(new URL(path,location.href).searchParams.get('customily_upsell')==='1')return null;}catch(_){return null;}
    var items=data&&data.items||data&&data.id&&[data]||[];
    if(!items.some(function(item){var props=item.properties||{};return Number(item.id)>0&&Number(item.id)!==51761795170550&&!props._ss_charm_spend_gift&&!props._ss_cu_offer&&!props['_customily-upsell-id'];}))return null;
    drawer.querySelectorAll('.ss-cart-add-error').forEach(function(el){el.remove();});
    var token={phase:'request',closeRevision:closeRevision};earlyAdds.push(token);setBusy(true);
    if(!overlayOpen())originalOpen(document.activeElement);
    return token;
  }
  function finishAdd(token,success) {
    if(!token||earlyAdds.indexOf(token)<0)return;
    if(!success){token.phase='recover';refresh(false).then(function(){releaseAdd(token,pendingConfig().failure);},function(){releaseAdd(token,pendingConfig().failure);});return;}
    token.phase='render';
    token.timer=setTimeout(function(){
      if(earlyAdds.indexOf(token)<0)return;
      refresh(false).then(function(){releaseAdd(token);},function(e){releaseAdd(token,e.message);});
    },12000);
  }
  function error(message) {
    var el=drawer && drawer.querySelector('#CartDrawer-CartErrors');
    if (el) el.textContent=message || '';
    var pageError=document.getElementById('cart-errors');
    if (pageError) pageError.textContent=message || '';
    if(message && currentCart) document.querySelectorAll('[data-ss-cart-key],cart-items .ink-cart-row').forEach(function(row){
      var key=row.dataset.ssCartKey||row.dataset.itemKey;
      var item=currentCart.items.find(function(i){return i.key===key;});
      var input=row.querySelector('[data-ss-cart-quantity],.quantity__input');
      if(item&&input)input.value=item.quantity;
    });
    if (message) document.dispatchEvent(new CustomEvent('soulyshine:drawer:error', {detail:{message:message}}));
  }
  function remember() {
    var state={details:[], key:null, control:null, upsell:null};
    drawer.querySelectorAll('[data-ss-cart-key]').forEach(function (row) {
      var toggle=row.querySelector('.ink-toggle-details');
      if (toggle && toggle.getAttribute('aria-expanded')==='true') state.details.push(row.dataset.ssCartKey);
    });
    var active=document.activeElement, row=active && active.closest('[data-ss-cart-key]');
    if(active && active.hasAttribute('data-ss-cu-check'))state.upsell=active.dataset.ssCuOffer;
    if (row) {state.key=row.dataset.ssCartKey;state.control=active.hasAttribute('data-ss-cart-quantity')?'input':active.getAttribute('data-ss-cart-step');}
    return state;
  }
  function restore(state, detailsOnly) {
    state.details.forEach(function (key) {
      var row=rowFor(key), toggle=row&&row.querySelector('.ink-toggle-details');
      if(!toggle)return;var panel=document.getElementById(toggle.dataset.target);
      if(panel){panel.hidden=false;toggle.setAttribute('aria-expanded','true');var label=toggle.querySelector('.ink-toggle-label');if(label)label.textContent='Hide details';}
    });
    if (detailsOnly || !drawer.classList.contains('active') || overlayOpen()) return;
    var row=state.key&&rowFor(state.key);
    var target=row&&(state.control==='input'?row.querySelector('[data-ss-cart-quantity]'):Array.from(row.querySelectorAll('[data-ss-cart-step]')).find(function(b){return b.dataset.ssCartStep===state.control;}));
    if(state.upsell)target=Array.from(drawer.querySelectorAll('[data-ss-cu-check]')).find(function(el){return el.dataset.ssCuOffer===state.upsell;});
    target=target||drawer.querySelector('.drawer__close');
    if(typeof trapFocus==='function')trapFocus(drawer.querySelector('#CartDrawer'),target);
  }
  function bindCartElements() {
    // Preserve Shrine's component API while routing this theme's cart edits
    // through one key-based writer. Do not replace product-form/ATC handlers.
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) {
      if(el.__ssDrawerBound)return;el.__ssDrawerBound=true;
      el.onCartUpdate=function(){};
      el.onChange=function(){};
      el.updateCart=function(){return refresh(false);};
      el.updateQuantity=function(line, quantity){
        var selector=el.tagName==='CART-ITEMS'?'#CartItem-'+line:'#SSCartDrawer-Item-'+line;
        var row=el.querySelector(selector)||el.querySelector('[data-index="'+line+'"]');
        if(row)row=row.closest('[data-ss-cart-key],.ink-cart-row')||row;
        var key=row&&(row.dataset.ssCartKey||row.dataset.itemKey||row.dataset.key);
        if(key)return change(key,Number(quantity));
        return refresh(false);
      };
    });
  }
  async function render(result, cart, shouldOpen, source, added, skipPromotion) {
    var promotion=window.SSCharmGift;
    if(promotion && promotion.active()&&!skipPromotion){
      var giftResult;try{giftResult=await promotion.reconcile(cart,{read:readCart,update:writeUpdates,cartFromResponse:function(response){var cart=cartFromSections(response&&response.sections);if(cart)cart.sections=response.sections;return cart;},renderedPost:function(path,body){return request(route(path),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(Object.assign({},body,{sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search}))});},post:function(path,body){if(body.discount!==undefined)body=Object.assign({},body,{sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search});return request(route(path),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});}},{previous:currentCart,added:added,freshSnapshot:true});
      }catch(e){
        try{var recovered=await readCart();await render(await sections(),recovered,false,'soulyshine-gift-error',undefined,true);}catch(_){}
        throw e;
      }
      cart=giftResult.cart;
      if(giftResult.renderChanged||(giftResult.renderChanged===undefined&&giftResult.changed))result=cartFromSections(cart.sections)?cart.sections:await sections();
    }
    var state=remember();
    // Disabling a focused control may already have blurred it. Keep the focus
    // identity captured before the task became busy if the user has not moved on.
    if(taskFocus&&taskFocus.revision===interactionRevision){state.key=taskFocus.state.key;state.control=taskFocus.state.control;state.upsell=taskFocus.state.upsell;}
    nativeRendering=true;
    try {originalRender({sections:result},true);} finally {nativeRendering=false;}
    ['main-cart-items','main-cart-footer'].forEach(function(id){
      var el=document.getElementById(id);if(!el||!result[el.dataset.id])return;
      var parsed=new DOMParser().parseFromString(result[el.dataset.id],'text/html').getElementById(id);
      var target=el.querySelector('.js-contents'), source=parsed&&parsed.querySelector('.js-contents');
      if(target&&source)target.innerHTML=source.innerHTML;
      var checkout=el.querySelector('#checkout'),renderedCheckout=parsed&&parsed.querySelector('#checkout');
      if(checkout&&renderedCheckout&&(el.classList.contains('is-empty')||renderedCheckout.disabled)){
        if(Object.prototype.hasOwnProperty.call(checkout.dataset,'ssWasDisabled'))checkout.dataset.ssWasDisabled=renderedCheckout.disabled?'true':'false';
        else checkout.disabled=renderedCheckout.disabled;
      }
      el.classList.toggle('is-empty',cart.item_count===0);
      var outer=el.closest('cart-items');if(outer)outer.classList.toggle('is-empty',cart.item_count===0);
    });
    if(cart.sections){cart=Object.assign({},cart);delete cart.sections;}
    currentCart=cart;
    var seed=drawer.querySelector('[data-ss-cart-state]');if(seed)seed.textContent=JSON.stringify(currentCart);
    drawer.setAttribute('data-ss-cart-render-source',source||'soulyshine-drawer');
    drawer.classList.toggle('is-empty',currentCart.item_count===0);
    groupRows(currentCart);bindCartElements();
    // Section replacement creates new controls. Record their own disabled
    // state rather than enabling checkout or overwriting an existing snapshot.
    if(busy)setBusy(true);
    if(window.SoulyshineCartUI)window.SoulyshineCartUI.refresh();
    if(window.SSCharmGift)window.SSCharmGift.view(currentCart);
    if(shouldOpen&&!overlayOpen()) {originalOpen(document.activeElement);}
    else {
      restore(state,true);
      if(taskFocus&&taskFocus.revision===interactionRevision)pendingFocusRestore={state:state,revision:interactionRevision};
    }
    // Keep review navigation on the same unpublished theme.
    if(previewId)drawer.querySelectorAll('a[href]').forEach(function(a){var u=new URL(a.href,location.origin);if(u.origin===location.origin){u.searchParams.set('preview_theme_id',previewId);a.href=u.toString();}});
    var status=drawer.querySelector('#CartDrawer-LineItemStatus');
    var countHeading=drawer.querySelector('[data-ss-main-item-count]');
    var mainCount=countHeading?Number(countHeading.dataset.ssMainItemCount):null;
    if(status)status.textContent=Number.isSafeInteger(mainCount)?'Cart updated. '+mainCount+(mainCount===1?' item.':' items.'):'Cart updated.';
    var detail={source:source||'soulyshine-drawer',renderer:'soulyshine-drawer',cart:currentCart,cartUpdatedAt:Date.now()};
    if(added&&added.length)detail.addedItems=added;
    document.dispatchEvent(new CustomEvent('soulyshine:cart:updated',{detail:detail}));
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:detail}));
    document.dispatchEvent(new CustomEvent('soulyshine:drawer:ready',{detail:{cart:currentCart}}));
  }
  function queue(task) {
    pendingTasks++;
    running=running.catch(function(){}).then(async function(){
      taskFocus={state:remember(),revision:interactionRevision};pendingFocusRestore=null;
      setBusy(true);error('');
      try{return await task();}catch(e){error(e.message);throw e;}
      finally{
        pendingTasks--;
        setBusy(false);
        var focus=pendingFocusRestore;pendingFocusRestore=null;taskFocus=null;
        if(focus&&focus.revision===interactionRevision)restore(focus.state);
        if(queuedRefresh)scheduleRefreshTimer();
      }
    });
    return running;
  }
  function renderAddResponse(state, shouldOpen) {
    var cart=cartFromSections(state&&state.sections), added=addedLines(state);
    var useResponse=pendingTasks===0&&responseMatchesCart(cart,added);
    var uiTokens=earlyAdds.filter(function(token){return token.phase==='render';});
    var requestedCloseRevision=uiTokens.length?Math.min.apply(null,uiTokens.map(function(token){return token.closeRevision;})):closeRevision, requestedExternalRevision=externalRevision;
    pendingAddRenders++;
    var task=queue(async function(){
      var result, usedResponse=useResponse&&requestedExternalRevision===externalRevision;
      if(usedResponse){
        result=state.sections;
      }else{
        // Missing/stale sections need one fresh rendered view. Its embedded
        // cart JSON also supplies CRM, avoiding a separate cart.js read/poll.
        result=await sections();cart=cartFromSections(result);
        if(!cart)throw new Error('The cart data could not be loaded. Please refresh the page and open your cart again.');
      }
      // Earlier addon/cart notifications are already represented by this
      // acknowledged snapshot. Keep a follow-up for later external changes.
      if(requestedExternalRevision===externalRevision){
        queuedRefresh=false;clearTimeout(refreshTimer);refreshTimer=null;
      }
      await render(result,cart,shouldOpen&&requestedCloseRevision===closeRevision,
        usedResponse?'soulyshine-add-response':'soulyshine-add-reconcile',added);
      return currentCart;
    });
    return task.finally(function(){pendingAddRenders--;uiTokens.forEach(function(token){releaseAdd(token);});});
  }
  function refresh(shouldOpen, afterAdd, source) {
    // Capture at enqueue time so a close also cancels opens waiting behind
    // another cart operation. A later deliberate open starts a new request.
    var requestedCloseRevision=closeRevision;
    return queue(async function(){
      var cart=afterAdd?await settledCart():null;
      var result=await sections();
      if(!cart)cart=cartFromSections(result)||await readCart();
      await render(result,cart,shouldOpen&&requestedCloseRevision===closeRevision,source);
      return currentCart;
    });
  }
  function prepareCheckout(verify) {
    return queue(async function(){
      var cart=await readCart();
      if(verify){var verified=await verify(cart);if(!verified)return false;cart=verified.items?verified:await readCart();}
      var promotion=window.SSCharmGift;
      if(promotion&&promotion.active()){
        var result=await promotion.reconcile(cart,{read:readCart,update:writeUpdates,post:function(path,body){return request(route(path),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});}},{previous:currentCart,freshSnapshot:true});
        cart=result.cart;
      }
      currentCart=cart;
      var seed=drawer&&drawer.querySelector('[data-ss-cart-state]');if(seed)seed.textContent=JSON.stringify(cart);
      return cart;
    });
  }
  function enrichRules(cart) {
    cart.items.forEach(function(item){var row=rowFor(item.key),input=row&&row.querySelector('[data-ss-cart-quantity]');if(input)item.quantity_rule={min:Number(input.min)||1,max:input.max?Number(input.max):null,increment:Number(input.step)||1};});
    return cart;
  }
  function inventoryCheck(cart, updates) {
    var totals={};cart.items.forEach(function(item){totals[item.variant_id]=(totals[item.variant_id]||0)+(Object.prototype.hasOwnProperty.call(updates,item.key)?updates[item.key]:item.quantity);});
    cart.items.forEach(function(item){var row=rowFor(item.key);if(row&&row.dataset.ssInventoryManaged==='true'&&updates[item.key]>item.quantity&&totals[item.variant_id]>Number(row.dataset.ssInventoryQuantity))throw new Error('The requested quantity is not available. Please choose a lower quantity.');});
  }
  async function writeUpdates(updates,attributes) {
    var keys=Object.keys(updates);if(!keys.length&&!attributes)return readCart();
    // Customily's documented-in-source bypass prevents a second addon writer
    // from transforming this already-complete atomic plan. Product ATC is unchanged.
    var single=keys.length===1&&!attributes;
    var body=single?{id:keys[0],quantity:updates[keys[0]]}:{updates:updates};
    if(attributes)body.attributes=attributes;
    return request(route(single?'cart/change.js?customily_upsell=1':'cart/update.js?customily_upsell=1'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
  }
  function change(key, quantity) {
    return queue(async function(){
      var cart=enrichRules(await readCart());
      currentCart=cart;
      var updates=model.planChange(cart,key,quantity);
      inventoryCheck(cart,updates);
      var promotion=window.SSCharmGift,item=(cart.items||[]).find(function(i){return i.key===key;}),attributes=quantity===0&&promotion&&item&&promotion.owned(item)?promotion.declineAttributes(true):undefined;
      try {cart=await writeUpdates(updates,attributes);} catch(e) {
        // Never retry a potentially-applied mutation. Reconcile the display once.
        try{var recovered=await readCart();await render(await sections(),recovered,false);}catch(_){}
        throw e;
      }
      var integrity=model.planIntegrity(cart);
      if(Object.keys(integrity).length)cart=await writeUpdates(integrity);
      await render(await sections(),cart,false);
      return currentCart;
    });
  }

  function setGiftConsent(declined) {
    return queue(async function(){
      var promotion=window.SSCharmGift;if(!promotion)return currentCart;
      var cart=await readCart(),updates={};
      if(declined)(cart.items||[]).filter(promotion.owned).forEach(function(item){updates[item.key]=0;});
      try{cart=await writeUpdates(updates,promotion.declineAttributes(declined));}
      catch(e){try{await render(await sections(),await readCart(),false);}catch(_){}throw e;}
      await render(await sections(),cart,false);return currentCart;
    });
  }

  // A set uses the existing serialized cart queue and one Shopify add request.
  function addSet(items) {
    if(!originalRender)return Promise.reject(new Error('Your cart is still loading. Please try again.'));
    return queue(async function(){
      var state;
      try {
        state=await request(route('cart/add.js?customily_upsell=1'),{
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:items,sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search})
        });
      }catch(e){
        e.cartUncertain=true;
        try{var recovered=await readCart();await render(await sections(),recovered,true,'soulyshine-drawer');}catch(_){}
        e.message='Your set could not be confirmed. Please review your cart before trying again.';
        throw e;
      }
      try{
        var result=state.sections,cart=cartFromSections(result);
        if(!cart){result=await sections();cart=cartFromSections(result)||await readCart();}
        await render(result,cart,true,'soulyshine-drawer',addedLines(state));
        return{added:true,rendered:true};
      }catch(e){return{added:true,rendered:false};}
    });
  }

  // The same queue serializes upsells, normal quantities, and drawer refreshes.
  function toggleUpsell(offerId, checked, catalog) {
    return queue(async function () {
      var rules=window.SSCartUpsellRules;
      if(!rules)throw new Error('Matching accessories are still loading. Please try again.');
      var cart=await readCart();
      currentCart=cart;
      var offer=rules.buildOffers(cart,catalog).find(function(candidate){return candidate.id===offerId;});
      var result, added=[];
      try {
        if(checked){
          if(!offer)throw new Error('Your cart changed. Please choose a matching accessory again.');
          if(!offer.addedLineKeys.length && !offer.externalAdded){
            var response=await request(route('cart/add.js?customily_upsell=1'),{
              method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({items:[{id:offer.variantId,quantity:1,properties:offer.properties}],
                sections:sectionIds(),sections_url:contextUrl().pathname+contextUrl().search})
            });
            added=addedLines(response);
            cart=cartFromSections(response.sections);
            if(cart)result=response.sections;
          }
        }else{
          // Only remove lines owned by this specific offer, using current keys.
          var targetIds=[catalog.necklace,catalog.charm].filter(Boolean).map(function(p){return String(p.id);});
          var updates={};
          cart.items.forEach(function(item){
            if((item.properties||{})._ss_cu_offer===offerId && targetIds.indexOf(String(item.product_id))!==-1)updates[item.key]=0;
          });
          if(Object.keys(updates).length)cart=await writeUpdates(updates);
        }
        if(!result){result=await sections();cart=cartFromSections(result)||await readCart();}
        await render(result,cart,false,'soulyshine-drawer',added);
        return currentCart;
      }catch(e){
        // Never retry a mutation blindly: reconcile a possible acknowledged add.
        try{var recovered=await readCart();await render(await sections(),recovered,false,'soulyshine-drawer');}catch(_){}
        throw e;
      }
    });
  }
  function catchAction(promise){promise.catch(function(e){console.warn('[Soulyshine drawer]',e.message);});}
  function rowKey(row){return row&&(row.dataset.ssCartKey||row.dataset.itemKey);}
  function onClick(event){
    var addButton=event.target.closest&&event.target.closest('#customily-cart-btn,form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]');
    // Only stop a new user initiation. Customily's synthetic original-button
    // click can belong to an already-running design whose addons are saved.
    if((pendingAddRenders||earlyAdds.length)&&event.isTrusted&&addButton){event.preventDefault();event.stopImmediatePropagation();return;}
    // Shrine binds the initial backdrop directly to its original close method
    // in its constructor. Capture that click too, before the bound handler runs.
    var closeTarget=event.target.closest&&event.target.closest('#CartDrawer-Overlay,.drawer__close');
    if(closeTarget&&drawer.contains(closeTarget)){closeRevision++;return;}
    var target=event.target.closest&&event.target.closest('[data-ss-cart-step],[data-ss-cart-remove], cart-items .ink-cart-row cart-remove-button');
    if(!target)return;
    var row=target.closest('[data-ss-cart-key],.ink-cart-row'),key=rowKey(row);if(!key)return;
    event.preventDefault();event.stopImmediatePropagation();if(busy)return;
    var input=row.querySelector('[data-ss-cart-quantity],.quantity__input');
    var quantity=target.hasAttribute('data-ss-cart-step')?Number(input.value)+Number(target.dataset.ssCartStep)*(Number(input.step)||1):0;
    catchAction(change(key,Math.max(0,quantity)));
  }
  function onChange(event){
    var target=event.target;if(!target.matches('[data-ss-cart-quantity], cart-items .ink-cart-row .quantity__input'))return;
    var key=rowKey(target.closest('[data-ss-cart-key],.ink-cart-row'));if(!key)return;
    event.stopImmediatePropagation();if(busy)return;catchAction(change(key,Number(target.value)));
  }
  function scheduleExternalRefresh(event){
    if(event&&event.detail&&(event.detail.source==='soulyshine-drawer'||event.detail.renderer==='soulyshine-drawer'))return;
    externalRevision++;queuedRefresh=true;scheduleRefreshTimer();
  }
  function scheduleRefreshTimer(){
    clearTimeout(refreshTimer);refreshTimer=setTimeout(function(){
      refreshTimer=null;
      // Keep only one follow-up while another task is reading/writing the cart.
      // Its finally block will schedule this after the active task completes.
      if(busy||!queuedRefresh)return;
      queuedRefresh=false;catchAction(refresh(false));
    },300);
  }
  async function boot(){
    drawer=document.querySelector('cart-drawer[data-ss-drawer-version]');model=window.SoulyshineCartModel;
    if(!drawer||!model)return;
    await customElements.whenDefined('cart-drawer');
    originalRender=drawer.renderContents.bind(drawer);originalOpen=drawer.open.bind(drawer);originalClose=drawer.close.bind(drawer);
    drawer.renderContents=function(state,dontOpen){if(nativeRendering)return originalRender(state,dontOpen);var task=renderAddResponse(state,!dontOpen);catchAction(task);return task;};
    drawer.open=function(trigger){if(trigger&&drawer.setActiveElement)drawer.setActiveElement(trigger);originalOpen(trigger);catchAction(refresh(false));};
    drawer.close=function(){closeRevision++;originalClose();};
    currentCart=seedCart();groupRows(currentCart);bindCartElements();
    readySession().catch(function(e){console.warn('[Soulyshine drawer session]',e.message);});
    // Cancel deferred focus restoration when the user starts a new interaction.
    document.addEventListener('pointerdown',function(){interactionRevision++;},true);
    document.addEventListener('keydown',function(){interactionRevision++;},true);
    document.addEventListener('click',onClick,true);document.addEventListener('change',onChange,true);
    document.addEventListener('cart:updated',scheduleExternalRefresh);
    window.addEventListener('pageshow',function(e){if(e.persisted)catchAction(refresh(false));});
  }
  window.SoulyshineDrawer={version:VERSION,build:'20261006-cart-instant-1',beginAdd:beginAdd,finishAdd:finishAdd,refresh:refresh,prepareCheckout:prepareCheckout,setGiftConsent:setGiftConsent,readySession:readySession,change:change,toggleUpsell:toggleUpsell,addSet:addSet,getCart:function(){return currentCart;}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){catchAction(boot());},{once:true});else catchAction(boot());
})();
